import { Navigate, Outlet } from "react-router-dom";
import { useStoreUserDetails } from "hooks/useStoreUserDetails";
import { useSelector } from "react-redux";

import { Loader } from "components/Loaders/Loader";

export const AuthProtectedRoutes = () => {
  const { loading, initializing } = useStoreUserDetails();
  const isUserAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated
  );
  const currentUsersDept = useSelector((state) => state.user.state.dept);
  const isUnderMaintenance = useSelector(
    (state) => state.companyAccess.state.isUnderMaintenance
  );
  if (currentUsersDept !== "SU" && isUnderMaintenance) {
    return <Navigate to="/maintenance" />;
  }
  if (initializing) {
    return <Loader />;
  }
  if (loading) {
    return <Loader />;
  }
  if (isUserAuthenticated) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
};
